module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114137_91_157.27c65ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114137_91_157.jpg
// module id = Eqqe
// module chunks = 0